/*(function () {
  const RULES = [
    {
      selector: '.postco-continue-without-line',
      text: 'Continue Without Purchase Protection'
    },
    {
      selector: '.postco-checkout-plus-flex-product .item-title span',
      text: 'Add Purchase Protection +'
    },
    {
      selector: '.postco-checkout-plus-flex-product .item-description',
      text: 'Added peace of mind with protection against loss, damage, or theft during transit, plus complimentary returns.'
    }
  ];

  function applyChanges() {
    let updated = false;

    RULES.forEach(rule => {
      document.querySelectorAll(rule.selector).forEach(el => {
        if (el.textContent.trim() !== rule.text) {
          el.textContent = rule.text;
          updated = true;
        }
      });
    });

    return updated;
  }

  // Initial attempt (in case DOM is already ready)
  applyChanges();

  const observer = new MutationObserver(() => {
    applyChanges();
  });f

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
*/









/* PostCo Checkout+ parcel protection info bubble copy */
(function () {
  var INFO_BUBBLE_TEXT =
    'Checkout+ – £4.99\n\n' +
    'Checkout+ is an optional service providing complimentary return postage for eligible returns, together with additional parcel protection for loss or damage during transit. The £4.99 charge applies to this order only and is added to your order total when Checkout+ is selected.\n\n' +
    'Return eligibility remains subject to our Returns Policy (https://www.harperkendall.com/pages/returns) and parcel protection is subject to the applicable Checkout+ terms and exclusions. Checkout+ is additional to, and does not affect, your statutory consumer rights.';

  function patchPostCoConfig(config) {
    if (!config || !config.uiCustomizations) return config;

    config.uiCustomizations.checkoutPlusOptionalProtectionModalContent = INFO_BUBBLE_TEXT;
    return config;
  }

  function patchExistingConfig() {
    if (window.PostCoFlexReturnConfig) {
      patchPostCoConfig(window.PostCoFlexReturnConfig);
    }
  }

  var storedConfig = window.PostCoFlexReturnConfig;

  try {
    Object.defineProperty(window, 'PostCoFlexReturnConfig', {
      configurable: true,
      enumerable: true,
      get: function () {
        return storedConfig;
      },
      set: function (value) {
        storedConfig = patchPostCoConfig(value);
      }
    });
  } catch (e) {
    // Fallback if the property is already non-configurable
  }

  patchExistingConfig();

  var tries = 0;
  var timer = setInterval(function () {
    patchExistingConfig();
    tries++;
    if (tries >= 20) clearInterval(timer);
  }, 250);
})();

document.addEventListener('DOMContentLoaded', function () {
  function initPostcoToggle() {
    const checkbox = document.querySelector('#postco-pp-checkbox');
    if (!checkbox) return;
    if (checkbox.dataset.hkInitialized === 'true') return;

    checkbox.dataset.hkInitialized = 'true';

    // Hide original checkbox (keep functionality)
    checkbox.style.position = 'absolute';
    checkbox.style.opacity = '0';
    checkbox.style.pointerEvents = 'none';
    checkbox.style.width = '1px';
    checkbox.style.height = '1px';
    checkbox.style.margin = '0';

    // Create switch UI ONLY (no text)
    const switchUI = document.createElement('span');
    switchUI.className = 'hk-switch hk-switch--postco';

    const ui = document.createElement('span');
    ui.className = 'hk-switch__ui';
    ui.setAttribute('aria-hidden', 'true');

    switchUI.appendChild(ui);

    // Insert right after checkbox
    checkbox.insertAdjacentElement('afterend', switchUI);

    // Toggle real checkbox on click
    switchUI.addEventListener('click', function (e) {
      e.preventDefault();
      checkbox.click();
    });

    // Sync state
    function syncState() {
      switchUI.classList.toggle('is-checked', checkbox.checked);
    }

    checkbox.addEventListener('change', syncState);
    syncState();
  }

  initPostcoToggle();

  // Re-run if app re-renders
  let postcoScheduled = false;
  const observer = new MutationObserver(function () {
    if (postcoScheduled) return;
    postcoScheduled = true;
    requestAnimationFrame(function () {
      postcoScheduled = false;
      initPostcoToggle();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

/**
 * Require explicit variant selection before add to cart / buy now.
 */
(function () {
  const PROMPT = window.themeVariables?.strings?.selectVariantPrompt || 'Please choose a variant above';
  const SHOPIFY_VARIANT_ERRORS = ['Cannot find variant', 'cannot find variant'];

  function getVariantPicker(form) {
    return document.querySelector(`variant-picker[form-id="${form.id}"]`);
  }

  function getRequiredOptionCount(picker) {
    return picker.querySelectorAll('fieldset.variant-picker__option').length;
  }

  function getSelectedOptionCount(form) {
    return form.querySelectorAll('input[data-option-position]:checked').length;
  }

  function isVariantFullySelected(form) {
    const picker = getVariantPicker(form);
    if (!picker || !picker.hasAttribute('data-requires-selection')) {
      return true;
    }

    const idInput = form.querySelector('[name="id"]');
    if (!idInput?.value) {
      return false;
    }

    const required = getRequiredOptionCount(picker);
    if (required === 0) {
      return true;
    }

    const selected = getSelectedOptionCount(form);
    return selected === required;
  }

  function getBuyButtons(form) {
    return document.querySelectorAll(`buy-buttons[form="${form.id}"]`);
  }

  function ensureMessageElement(buyButtons) {
    let message = buyButtons.querySelector('.variant-selection-message');

    if (!message) {
      message = document.createElement('div');
      message.className = 'variant-selection-message';
      message.setAttribute('role', 'alert');
      message.hidden = true;
      buyButtons.prepend(message);
    }

    return message;
  }

  function showVariantError(form) {
    const picker = getVariantPicker(form);
    if (!picker) return;

    getBuyButtons(form).forEach((buyButtons) => {
      const message = ensureMessageElement(buyButtons);
      message.textContent = PROMPT;
      message.hidden = false;
    });

    const stickyMessage = document.querySelector('#custom-sticky-cta .variant-selection-message');
    if (stickyMessage) {
      stickyMessage.textContent = PROMPT;
      stickyMessage.hidden = false;
    }

    picker.querySelectorAll('fieldset.variant-picker__option').forEach((fieldset) => {
      const position = fieldset.querySelector('input[data-option-position]')?.getAttribute('data-option-position');
      const hasSelection = position
        ? Boolean(form.querySelector(`input[data-option-position="${position}"]:checked`))
        : false;

      fieldset.classList.toggle('variant-picker__option--error', !hasSelection);
    });

    const firstError = picker.querySelector('.variant-picker__option--error');
    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function clearVariantError(form) {
    const picker = getVariantPicker(form);
    picker?.querySelectorAll('.variant-picker__option--error').forEach((fieldset) => {
      fieldset.classList.remove('variant-picker__option--error');
    });

    getBuyButtons(form).forEach((buyButtons) => {
      const message = buyButtons.querySelector('.variant-selection-message');
      if (message) {
        message.hidden = true;
        message.textContent = '';
      }
    });

    const stickyMessage = document.querySelector('#custom-sticky-cta .variant-selection-message');
    if (stickyMessage) {
      stickyMessage.hidden = true;
      stickyMessage.textContent = '';
    }
  }

  function updateVariantSelectionState(form) {
    const picker = getVariantPicker(form);
    if (!picker || !picker.hasAttribute('data-requires-selection')) {
      return;
    }

    const idInput = form.querySelector('[name="id"]');
    const valid = isVariantFullySelected(form);

    if (idInput) {
      idInput.disabled = !valid;
      if (!valid) {
        idInput.value = '';
      }
    }

    form.querySelectorAll('button[type="submit"][form="' + form.id + '"], buy-buttons button[type="submit"]').forEach((button) => {
      button.classList.toggle('is-variant-unselected', !valid);
      button.setAttribute('aria-disabled', valid ? 'false' : 'true');
    });

    document.querySelectorAll('#custom-sticky-cta button[type="submit"], #custom-sticky-buy-now').forEach((button) => {
      button.classList.toggle('is-variant-unselected', !valid);
      button.setAttribute('aria-disabled', valid ? 'false' : 'true');
    });

    if (valid) {
      clearVariantError(form);
    }
  }

  function bindForm(form) {
    if (!form || form.dataset.hkVariantGuardBound === 'true') {
      return;
    }

    const picker = getVariantPicker(form);
    const requiresSelection = picker?.hasAttribute('data-requires-selection');
    form.dataset.hkVariantGuardBound = 'true';

    if (!requiresSelection) {
      const idInput = form.querySelector('[name="id"]');
      if (idInput?.value) {
        idInput.disabled = false;
      }
      return;
    }

    updateVariantSelectionState(form);

    const idInput = form.querySelector('[name="id"]');
    if (idInput) {
      const idObserver = new MutationObserver(function () {
        updateVariantSelectionState(form);
      });
      idObserver.observe(idInput, { attributes: true, attributeFilter: ['disabled', 'value'] });
    }

    form.addEventListener('variant:change', () => {
      updateVariantSelectionState(form);
    });

    form.addEventListener('change', () => {
      updateVariantSelectionState(form);
    });

    form.addEventListener('product:rerender', () => {
      window.requestAnimationFrame(() => updateVariantSelectionState(form));
    });
  }

  function initVariantSelectionGuard() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(bindForm);
  }

  function replaceShopifyVariantError(detail) {
    if (!detail) {
      return;
    }

    const message = detail.error || detail.message;
    if (message && SHOPIFY_VARIANT_ERRORS.some((text) => message.toLowerCase().includes(text.toLowerCase()))) {
      if ('error' in detail) {
        detail.error = PROMPT;
      }
      if ('message' in detail) {
        detail.message = PROMPT;
      }
    }
  }

  document.addEventListener('cart:error', function (event) {
    replaceShopifyVariantError(event.detail);

    const form = event.target;
    if (!form?.matches?.('form[action*="/cart/add"]')) {
      return;
    }

    const picker = getVariantPicker(form);
    if (!picker?.hasAttribute('data-requires-selection')) {
      return;
    }

    if (!isVariantFullySelected(form)) {
      showVariantError(form);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) {
      return;
    }

    const picker = getVariantPicker(form);
    if (!picker || !picker.hasAttribute('data-requires-selection')) {
      return;
    }

    if (!isVariantFullySelected(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showVariantError(form);
    }
  }, true);

  document.addEventListener('click', function (event) {
    const buyNowBtn = event.target.closest('#custom-sticky-buy-now');
    if (!buyNowBtn) {
      return;
    }

    const sticky = buyNowBtn.closest('#custom-sticky-cta');
    const formId = sticky?.querySelector('button[form]')?.getAttribute('form');
    const form = formId ? document.getElementById(formId) : null;

    if (!form || isVariantFullySelected(form)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    showVariantError(form);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSelectionGuard);
  } else {
    initVariantSelectionGuard();
  }

  let guardScheduled = false;
  const pageObserver = new MutationObserver(function () {
    if (guardScheduled) return;
    guardScheduled = true;
    requestAnimationFrame(function () {
      guardScheduled = false;
      initVariantSelectionGuard();
    });
  });

  pageObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();








/*salesfire search placeholder to be mirrored (desktop header input)*/
(function () {
  var OUR_SELECTOR = '.header__search-input';
  var SF_IFRAME_ID = 'sf-search-iframe';
  var SF_INPUT_SELECTOR = '.search-bar__input';

  var PHRASES = [
    'How can we help you today?',
    'Search diamond rings...',
    'Search gold pendants...',
    'Search bracelets...'
  ];
  var TYPE_SPEED = 70;
  var DELETE_SPEED = 35;
  var HOLD_FULL = 1800;
  var HOLD_EMPTY = 500;

  var HIDDEN_RECHECK = 1000;

  var ourInput = null;
  var mirroring = false;
  var sfInput = null;
  var typeTimer = null;
  var placeholderObserver = null;

  function isInputShown() {
    if (document.hidden) return false;
    if (ourInput.checkVisibility) return ourInput.checkVisibility();
    return ourInput.offsetParent !== null;
  }

  function startTypewriter() {
    var phraseIndex = 0;
    var charIndex = 0;
    var deleting = false;

    function tick() {
      if (mirroring) return;

      // The desktop input is display:none on mobile; animating it there only burns main-thread time.
      if (!isInputShown()) {
        typeTimer = setTimeout(tick, HIDDEN_RECHECK);
        return;
      }

      var phrase = PHRASES[phraseIndex];

      if (!deleting) {
        charIndex++;
        ourInput.placeholder = phrase.slice(0, charIndex);
        if (charIndex >= phrase.length) {
          deleting = true;
          typeTimer = setTimeout(tick, HOLD_FULL);
          return;
        }
        typeTimer = setTimeout(tick, TYPE_SPEED);
      } else {
        charIndex--;
        ourInput.placeholder = phrase.slice(0, charIndex);
        if (charIndex <= 0) {
          deleting = false;
          phraseIndex = (phraseIndex + 1) % PHRASES.length;
          typeTimer = setTimeout(tick, HOLD_EMPTY);
          return;
        }
        typeTimer = setTimeout(tick, DELETE_SPEED);
      }
    }

    tick();
  }

  function stopTypewriter() {
    if (typeTimer) {
      clearTimeout(typeTimer);
      typeTimer = null;
    }
  }

  function bindMirror(input) {
    if (input === sfInput) return;

    if (placeholderObserver) placeholderObserver.disconnect();

    sfInput = input;
    mirroring = true;
    stopTypewriter();

    ourInput.placeholder = sfInput.getAttribute('placeholder') || '';

    placeholderObserver = new MutationObserver(function () {
      ourInput.placeholder = sfInput.getAttribute('placeholder') || '';
    });

    placeholderObserver.observe(sfInput, {
      attributes: true,
      attributeFilter: ['placeholder']
    });
  }

  function unbindMirror() {
    if (placeholderObserver) placeholderObserver.disconnect();
    placeholderObserver = null;
    sfInput = null;
    mirroring = false;
    startTypewriter();
  }

  function scan() {
    if (mirroring && sfInput && !sfInput.isConnected) {
      unbindMirror();
    }
    if (mirroring || !isInputShown()) return;

    var iframe = document.getElementById(SF_IFRAME_ID);
    if (!iframe) return;

    var doc;
    try {
      doc = iframe.contentDocument;
    } catch (e) {
      return;
    }
    if (!doc) return;

    var input = doc.querySelector(SF_INPUT_SELECTOR);
    if (input) bindMirror(input);
  }

  function init() {
    ourInput = document.querySelector(OUR_SELECTOR);
    if (!ourInput) return;

    startTypewriter();
    setInterval(scan, 800);
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Mobile header-search placeholder typewriter */
(function () {
  var PHRASES = [
    'How can we help you today?',
    'Search diamond rings...',
    'Search gold pendants...',
    'Search bracelets...'
  ];
  var TYPE_SPEED = 70;
  var DELETE_SPEED = 35;
  var HOLD_FULL = 2000;
  var HOLD_EMPTY = 500;

  var mobileInput = null;
  var headerSearch = null;
  var typeTimer = null;
  var running = false;
  var bound = false;

  function isSearchOpen() {
    return !!(headerSearch && headerSearch.hasAttribute('open'));
  }

  function stopTypewriter() {
    if (typeTimer) {
      clearTimeout(typeTimer);
      typeTimer = null;
    }
    running = false;
  }

  function startTypewriter(force) {
    if (!mobileInput) return;
    if (mobileInput.value) return;
    if (running && !force) return;

    stopTypewriter();
    running = true;

    var phraseIndex = 0;
    var charIndex = 0;
    var deleting = false;
    mobileInput.placeholder = '';

    function tick() {
      if (!running || !mobileInput) return;
      if (!isSearchOpen()) {
        stopTypewriter();
        return;
      }
      if (mobileInput.value) {
        stopTypewriter();
        return;
      }

      var phrase = PHRASES[phraseIndex];

      if (!deleting) {
        charIndex++;
        mobileInput.placeholder = phrase.slice(0, charIndex);
        if (charIndex >= phrase.length) {
          deleting = true;
          typeTimer = setTimeout(tick, HOLD_FULL);
          return;
        }
        typeTimer = setTimeout(tick, TYPE_SPEED);
      } else {
        charIndex--;
        mobileInput.placeholder = phrase.slice(0, charIndex);
        if (charIndex <= 0) {
          deleting = false;
          phraseIndex = (phraseIndex + 1) % PHRASES.length;
          typeTimer = setTimeout(tick, HOLD_EMPTY);
          return;
        }
        typeTimer = setTimeout(tick, DELETE_SPEED);
      }
    }

    typeTimer = setTimeout(tick, TYPE_SPEED);
  }

  function onSearchOpen() {
    // Re-query in case the dialog moved in the DOM
    if (headerSearch) {
      mobileInput = headerSearch.querySelector('.header-search__input') || mobileInput;
    }
    startTypewriter(true);
  }

  function onSearchClose() {
    stopTypewriter();
    if (mobileInput) mobileInput.placeholder = PHRASES[0];
  }

  function bind() {
    headerSearch =
      document.querySelector('header-search.header-search') ||
      document.querySelector('header-search');
    if (!headerSearch) return false;

    mobileInput = headerSearch.querySelector('.header-search__input');
    if (!mobileInput) return false;

    if (bound) return true;
    bound = true;

    headerSearch.addEventListener('dialog:before-show', onSearchOpen);
    headerSearch.addEventListener('dialog:after-show', onSearchOpen);
    headerSearch.addEventListener('dialog:after-hide', onSearchClose);

    new MutationObserver(function () {
      if (isSearchOpen()) onSearchOpen();
      else onSearchClose();
    }).observe(headerSearch, {
      attributes: true,
      attributeFilter: ['open']
    });

    mobileInput.addEventListener('input', function () {
      if (mobileInput.value) {
        stopTypewriter();
        mobileInput.placeholder = '';
      } else if (isSearchOpen()) {
        startTypewriter(true);
      }
    });

    // Search icon click (mobile) — start as soon as controls are used
    document.addEventListener(
      'click',
      function (event) {
        var trigger = event.target.closest('[aria-controls="' + headerSearch.id + '"]');
        if (!trigger) return;
        setTimeout(function () {
          if (isSearchOpen()) onSearchOpen();
        }, 50);
      },
      true
    );

    return true;
  }

  function init() {
    if (bind()) {
      if (isSearchOpen()) onSearchOpen();
      return;
    }

    // Header can render late; retry briefly
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (bind() || tries > 25) {
        clearInterval(timer);
        if (isSearchOpen()) onSearchOpen();
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();